import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Permission } from '../../auth/permissions';
import { BankPortalAuthService } from './bankportal-auth.service';
import { Observable } from 'rxjs';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private bankPortalAuthService: BankPortalAuthService
  ) { }

  public _userName!: string;
  get userName(): string {
    return this._userName;
  }
  set userName(userName: string) {
    this._userName = userName;
  }

  public _isLoggedIn!: boolean;
  get isLoggedIn(): boolean {
    return this._isLoggedIn;
  }
  set isLoggedIn(isLoggedIn: boolean) {
    this._isLoggedIn = isLoggedIn;

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    const requiredPermission = route?.data?.permission as Permission;
    const userPermissions = this.bankPortalAuthService?.user?.permissions;
    const user = this.bankPortalAuthService.user;

    const routeHasPermission: boolean = requiredPermission !== undefined;

    if (user && !routeHasPermission) {
      // route does not have permission set on it
      // which means access is allowed
      // no need to check for permissions
      return true;
    }

    if (!userPermissions) return false;

    for (let i = 0; i < userPermissions?.length; i++) {
      if (userPermissions.includes(requiredPermission)) {
        return true;
      }
    }
    return false;
  }


}
